export { default } from './DocumentDiscriminatorTag';
